"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectValidator = void 0;
const Validator_1 = require("../validator/Validator");
const ERRORS = {
    HAS_KEYS: 'HAS_KEYS',
    IS_OBJECT: 'IS_OBJECT',
    NO_ADDITIONAL_KEYS: 'NO_ADDITIONAL_KEYS',
    NOT_EMPTY: 'NOT_EMPTY',
    OBJECT_CONTENT: 'OBJECT_CONTENT',
    OBJECT_STRUCTURE: 'OBJECT_STRUCTURE',
};
class ObjectValidator extends Validator_1.Validator {
    static isObject(value) {
        return typeof value === 'object' && value !== null && !Array.isArray(value);
    }
    static notEmpty(value) {
        return Object.keys(value).length > 0;
    }
    static hasKeys(value, keys) {
        return keys.every(key => key in value);
    }
    static objectContent(value, contentType) {
        return _a.isObject(value) && Object.values(value).every(item => typeof item === contentType);
    }
    static objectStructure(value, fieldsValidator) {
        return _a.isObject(value) && fieldsValidator.validate(value).isSuccess;
    }
    static noAdditionalKeys(value, keys) {
        return Object.keys(value).every(key => keys.includes(key));
    }
}
exports.ObjectValidator = ObjectValidator;
_a = ObjectValidator;
/**
 * Validates if the object has specific keys.
 * @param keys - The keys that the object should have.
 */
ObjectValidator.HAS_KEYS = (keys) => _a.validatorFactory(value => _a.hasKeys(value, keys), ERRORS.HAS_KEYS);
/**
 * Validates if the value is an object.
 */
ObjectValidator.IS_OBJECT = () => _a.validatorFactory(_a.isObject, ERRORS.IS_OBJECT);
/**
 * Validates if the object has no additional keys other than the specified ones.
 * @param keys - The keys that the object should have.
 */
ObjectValidator.NO_ADDITIONAL_KEYS = (keys) => _a.validatorFactory(value => _a.noAdditionalKeys(value, keys), ERRORS.NO_ADDITIONAL_KEYS);
/**
 * Validates if the object is not empty.
 */
ObjectValidator.NOT_EMPTY = () => _a.validatorFactory(_a.notEmpty, ERRORS.NOT_EMPTY);
/**
 * Validates the content types of the object.
 * @param contentType - The type of the content that the object should have.
 * @example
 * const ruleToValidate = ObjectValidator.OBJECT_CONTENT<string>('string');
 * const result = ruleToValidate.validator({ key1: 'value1', key2: 'value2' });
 * console.log(result); // true
 *
 * const invalidResult = ruleToValidate.validator({ key1: 'value1', key2: 2 });
 * console.log(invalidResult); // false
 */
ObjectValidator.OBJECT_CONTENT = (contentType) => _a.validatorFactory(value => _a.objectContent(value, contentType), ERRORS.OBJECT_CONTENT);
/**
 * Validates the structure of the object using a FieldsValidator.
 * @param fieldsValidator - The FieldsValidator to validate the object structure.
 * @example
 * class ExampleObjectValidator extends FieldsValidator<ExampleDto> {
 *   constructor() {
 *     super();
 *     this.validableFields = {
 *       id: FieldValidatorFactory.create<number>([NumberValidator.IS_NUMBER()]),
 *       name: FieldValidatorFactory.create<string>([StringValidator.IS_STRING()]),
 *       roles: FieldValidatorFactory.create<string[]>([ArrayValidator.NOT_EMPTY(), ArrayValidator.ARRAY_CONTENT('string')]),
 *     };
 *   }
 * }
 *
 * const ruleToValidate = ObjectValidator.OBJECT_STRUCTURE<ExampleDto>(new ExampleObjectValidator());
 * const result = ruleToValidate.validator({ id: 1, name: 'John Doe', roles: ['admin', 'user'] });
 * console.log(result); // true
 *
 * const invalidResult = ruleToValidate.validator({ id: '1', name: 'John Doe', roles: ['admin', 'user'] });
 * console.log(invalidResult); // false
 */
ObjectValidator.OBJECT_STRUCTURE = (fieldsValidator) => _a.validatorFactory(value => _a.objectStructure(value, fieldsValidator), ERRORS.OBJECT_STRUCTURE);
//# sourceMappingURL=ObjectValidator.js.map